/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  WorkloadPlatformBlock,
  WorkloadPlatformBlock$inboundSchema,
} from "./workloadplatformblock.js";

/**
 * collect steps gather values, the create step writes the rows, connect steps describe the platform's side.
 */
export const Phase = {
  Collect: "collect",
  Create: "create",
  Connect: "connect",
} as const;
/**
 * collect steps gather values, the create step writes the rows, connect steps describe the platform's side.
 */
export type Phase = ClosedEnum<typeof Phase>;

/**
 * One screen of a guided setup.
 */
export type WorkloadPlatformStep = {
  /**
   * Rendered in order.
   */
  blocks: Array<WorkloadPlatformBlock>;
  /**
   * Stable within the platform; used in the dashboard URL.
   */
  id: string;
  /**
   * collect steps gather values, the create step writes the rows, connect steps describe the platform's side.
   */
  phase: Phase;
  /**
   * Heads the step.
   */
  title: string;
};

/** @internal */
export const Phase$inboundSchema: z.ZodMiniEnum<typeof Phase> = z.enum(Phase);

/** @internal */
export const WorkloadPlatformStep$inboundSchema: z.ZodMiniType<
  WorkloadPlatformStep,
  unknown
> = z.object({
  blocks: z.array(WorkloadPlatformBlock$inboundSchema),
  id: z.string(),
  phase: Phase$inboundSchema,
  title: z.string(),
});

export function workloadPlatformStepFromJSON(
  jsonString: string,
): SafeParseResult<WorkloadPlatformStep, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkloadPlatformStep$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkloadPlatformStep' from JSON`,
  );
}
